import { render, staticRenderFns } from "./AccountDia.vue?vue&type=template&id=fadc6a90&scoped=true"
import script from "./AccountDia.vue?vue&type=script&lang=js"
export * from "./AccountDia.vue?vue&type=script&lang=js"
import style0 from "./AccountDia.vue?vue&type=style&index=0&id=fadc6a90&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadc6a90",
  null
  
)

export default component.exports